export const NOW = 'NOW';
export const TODAY = 'TODAY';
export const WEEK = 'WEEK';
export const MONTH = 'MONTH';
export const QUARTER = 'QUARTER';
export const FISCAL_QUARTER = 'FISCAL_QUARTER';
export const YEAR = 'YEAR';
export const FISCAL_YEAR = 'FISCAL_YEAR';